export default __webpack_public_path__ + "static/brilliantly-warm-banner-3-a-dc60c402d9cb4a7755e3059ae3bc9c3f.webp";